import { createSelector, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

// A thematic covers the local days whose midnight falls within [date_from, date_to].
const toDayRange = (thematic) => {
    const from = dayjs(thematic.date_from);
    const firstDay = from.isSame(from.startOf('day')) ? from : from.startOf('day').add(1, 'day');

    return {
        thematic,
        start: firstDay.format('YYYY-MM-DD'),
        end: dayjs(thematic.date_to).format('YYYY-MM-DD'),
    };
}

// Parsed once per thematics change instead of on every tile render.
const selectThematicRanges = createSelector(
    state => state.thematics.thematics,
    thematics => thematics.map(toDayRange),
);

// Thematics covering `day` ('YYYY-MM-DD') in list order; select it with shallowEqual.
export const selectThematicsForDay = (state, day) => selectThematicRanges(state)
    .filter(range => range.start <= day && day <= range.end)
    .map(range => range.thematic);

// The highlighted thematic's name if it starts on `day`, otherwise null.
export const selectHighlightStartingOn = (state, day) => {
    const highlighted = state.thematics.highlightedThematics;
    if (highlighted == null) return null;

    const range = selectThematicRanges(state).find(r => r.thematic.id === highlighted.id);
    return range && range.start === day ? highlighted.name : null;
}

export const thematicsSlice = createSlice({
    name: 'thematics',
    initialState: {
        thematics: [],
        highlightedThematics: null,
    },

    reducers: {
        fetchThematics: (state, action) => {
            state.thematics = action.payload;
        },
        addThematic: (state, action) => {
            state.thematics.push(action.payload);
        },
        updateThematic: (state, action) => {

            state.thematics = state.thematics.map((item, index) => {
                if (item.id === action.payload.id) {
                    return action.payload
                }
                return item
            })

        },
        deleteThematic: (state, action) => {
            state.thematics = state.thematics.filter(thematic => thematic.id !== action.payload);
        },
        setHighlightedThematic: (state, action) => {
            state.highlightedThematics = action.payload
        }
    },
})

export const {
    fetchThematics,
    addThematic,
    updateThematic,
    deleteThematic,
    setHighlightedThematic,
} = thematicsSlice.actions;

export default thematicsSlice.reducer;